/**
 * @file コンポーネント：プライバシーポリシー確認モーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { Privacypolicy } from "~/src/components/projects/Privacypolicy";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            buttonlist={[
                {
                    buttonType: "submit",
                    disabled: !props.isAgreed,
                    onClick: (e) => props.fnSendPrivacypolicyAgreed(e),
                    text: localized["Label.Send"],
                },
            ]}
            content={[
                <Privacypolicy
                    isAgreed={props.isAgreed}
                    key="privacypolicy"
                    onColor="white"
                    setIsAgreed={props.setIsAgreed}
                />,
            ]}
            hasButtonClose={false}
            headline={localized["Label.PrivacyPolicy"]}
            isShow={props.isShow}
            setIsShow={() => void {}}
        />
    );
};
